import { render, staticRenderFns } from "./MatchOptionsPerson.vue?vue&type=template&id=5dd73f2c&scoped=true&"
import script from "./MatchOptionsPerson.vue?vue&type=script&lang=js&"
export * from "./MatchOptionsPerson.vue?vue&type=script&lang=js&"
import style0 from "./MatchOptionsPerson.vue?vue&type=style&index=0&id=5dd73f2c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd73f2c",
  null
  
)

export default component.exports